import { render } from "./PlantDetailsView.vue?vue&type=template&id=3cd6fc39&scoped=true&ts=true"
import script from "./PlantDetailsView.vue?vue&type=script&lang=ts"
export * from "./PlantDetailsView.vue?vue&type=script&lang=ts"

import "./PlantDetailsView.vue?vue&type=style&index=0&id=3cd6fc39&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd6fc39"]])

export default __exports__